import React from 'react'
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'
import AvantLandingLogo from '../images/avant_landing_logo.svg'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

const ProductInformation = () => {
  const links = [
    {
      label: 'Producer Guide',
      link: 'https://22504959.fs1.hubspotusercontent-na1.net/hubfs/22504959/NBFXPG5_25V1_NewBridge_Final_Expense_Producer_Guide_Digital_05122025%5B52%5D.pdf',
    },
    {
      label: 'Quick Guide',
      link: 'https://22504959.fs1.hubspotusercontent-na1.net/hubfs/22504959/NBFXQG5_25V1_NewBridge_Quick_Guide_Digital_05122025%5B85%5D.pdf',
    },
    {
      label: 'Consumer Brochure',
      link: '',
    },
    {
      label: 'Underwriting Guide',
      link: 'https://22504959.fs1.hubspotusercontent-na1.net/hubfs/22504959/NBFXUG5_25V1_NewBridge_Underwriting_Guide_Digital_05122025%5B69%5D.pdf',
    },
    {
      label: 'Build Chart',
      link: 'https://22504959.fs1.hubspotusercontent-na1.net/hubfs/22504959/documents/NBFXBC5_25V2_NewBridge_Build_Chart_Digital_05272025.pdf',
    },
    {
      label: 'Demo Video',
      link: 'https://vimeo.com/1088420892/2279d11121?share=copy',
    },
  ]

  return (
    <div
      style={{
        backgroundColor: 'rgba(241, 243, 246, 1)',
        paddingTop: '100px',
        fontFamily: 'Roboto',
        minHeight: '100vh',
      }}
    >
      <Stack width={'100%'} direction={'column'} gap={1} mb={6}>
        <Typography variant="h4">Product Information & Training</Typography>
        <Typography variant="subtitle2" sx={pInfoStyle.subtitle}>
          Click the links to access NewBridge Product Information & Training.
        </Typography>
      </Stack>

      <Paper elevation={3} sx={pInfoStyle.containerBox}>
        <Box
          component="img"
          src={AvantLandingLogo}
          sx={{
            width: '40%',
            padding: 'auto 100px',
            opacity: 1,
          }}
        />
        <Grid container rowGap={2}>
          {links.map((i, idx) => (
            <>
              <Grid item lg={6} md={6} xs={6} sm={6} display={'flex'} alignItems={'center'} gap={3}>
                <Typography variant="subtitle1" textAlign={'left'} sx={{ fontFamily: 'Roboto!important' }}>
                  {i.label}
                </Typography>
              </Grid>
              <Grid item lg={6} md={6} xs={6} sm={6} display={'flex'} justifyContent={'flex-end'}>
                <Button
                  target="_blank"
                  href={i.link}
                  size="small"
                  sx={pInfoStyle.openBtn}
                  variant="text"
                  endIcon={<KeyboardArrowRightIcon />}
                  // disabled={!i.isProduction}
                >
                  Open
                </Button>
              </Grid>
            </>
          ))}
        </Grid>
      </Paper>
      {/* Your component JSX goes here */}
    </div>
  )
}

const pInfoStyle = {
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    gap: 1,
    width: { lg: '626px', md: '770px', sm: '770px', xs: '343px' },
    maxWidth: { lg: '522px', md: '770px', sm: '770px', xs: '343px' },
    height: 'auto',
    background: '#FFFF',
    margin: 'auto',
    padding: '20px',
  },
  subtitle: {
    fontFamily: 'Roboto!important',
    fontWeight: '400!important',
    fontSize: '16px!important',
    color: '#64768C',
  },
  openBtn: {
    fontFamily: 'Roboto!important',
    fontWeight: '400!important',
    fontSize: '14px!important',
    textTransform: 'none',
  },
}

export default ProductInformation
